import '@mantine/core/styles.css';
import '@mantine/spotlight/styles.css';
import '@mantine/dropzone/styles.css';
import '@mantine/notifications/styles.css';

import { lazy, ReactNode, Suspense } from 'react';
import { BrowserRouter } from 'react-router-dom';

import { MantineProvider } from '@mantine/core';

import { AuthProvider } from '@/contexts';
import { Router } from './router';
import { theme } from './theme';

// Guided-demo builds swap the real AuthProvider for the demo shell (canned
// personas + presenter HUD). The literal env check lets production builds
// dead-code-eliminate the whole demo chunk.
const DemoShell =
  import.meta.env.VITE_DEMO_MODE === 'true'
    ? lazy(() => import('./demo/DemoShell').then((m) => ({ default: m.DemoShell })))
    : null;

function AuthBoundary({ children }: Readonly<{ children: ReactNode }>) {
  if (DemoShell) {
    return (
      <Suspense fallback={null}>
        <DemoShell>{children}</DemoShell>
      </Suspense>
    );
  }
  return <AuthProvider>{children}</AuthProvider>;
}

export default function App() {
  return (
    <MantineProvider theme={theme} forceColorScheme="light">
      <BrowserRouter>
        <AuthBoundary>
          <Router />
        </AuthBoundary>
      </BrowserRouter>
    </MantineProvider>
  );
}
